import { render } from "./CardPublication.vue?vue&type=template&id=1ad17852&scoped=true"
import script from "./CardPublication.vue?vue&type=script&lang=js"
export * from "./CardPublication.vue?vue&type=script&lang=js"

import "./CardPublication.vue?vue&type=style&index=0&id=1ad17852&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad17852"]])

export default __exports__